export enum PlatformIntegration {
  default = 'default',
  salesforce = 'salesforce'
}
